<template>
    <div>
        <myPage :max_flag="true">
            <div class="flex-box nopadding wrap pd-left5 pd-bottom5" slot="header">
                <el-button-group class="mg-right5 mg-top5 flex-box nopadding">
                    <el-button size="small" :title="$t('refs')" icon="el-icon-refresh" @click="getInfo()"></el-button>
                    <el-button size="small" v-print="printObj" :title="$t('print')" icon="el-icon-printer"></el-button>
                </el-button-group>
            </div>
            <div class="fillw fillh">
                <div class="width-800" id="print_area">
                    <mySubTitle class="pd-top10">接口文档地址</mySubTitle>
                    <div class="pd-10 bg-f8 mg-top5">
                        <div>
                            <a target="_blank" href="https://www.showdoc.com.cn/2598842987408390/11558858425749185">
                                https://www.showdoc.com.cn/2598842987408390/11558858425749185
                            </a>
                        </div>
                        <div class="mg-top5 flex-box nopadding">
                            访问秘钥：552288
                        </div>
                    </div>
                    <my-sub-title class="pd-top20">客户信息</my-sub-title>
                    <div class="bg-f8 mg-top5">
                        <div class="flex-box border-bottom-line">
                            <div class="width-150 tright">客户ID(org_id)：</div>
                            <div class="flex-box-bd tleft f-bd">{{info.org_id}}</div>
                        </div>
                        <div class="flex-box border-bottom-line">
                            <div class="width-150 tright">接口秘钥(api_key)：</div>
                            <div class="flex-box-bd tleft f-bd">{{info.api_key || '未生成'}}</div>
                            <div class="mg-left5">
                                <a class="link" @click="chkResetApiKey">{{info.api_key == ''?'生成':'更换'}}</a>
                            </div>
                        </div>
                        <div class="flex-box border-bottom-line">
                            <div class="width-150 tright">信誉额度：</div>
                            <el-tag size="small">{{info.cr_cat_cdesc}}</el-tag>
                            <div class="tleft f-bd mg-left5">{{info.cr_qty}}</div>
                            <div class="flex-box-bd tright">
                                <el-tag size="small" class="bg-white" v-if="info.day_cr_qty_min != ''">
                                    每日低于<span class="f-bd f-red mg-left3 mg-right3">{{info.day_cr_qty_min * 1}}</span>自动恢复
                                </el-tag>
                            </div>
                        </div>
                        <div class="flex-box">
                            <div class="flex-box-bd"></div>
                            <div>
                                <el-checkbox v-model="show_up_flag" true-label="1" false-label="0" @change="getInfo()">仅显示已上架商品</el-checkbox>
                            </div>
                        </div>
                    </div>
                    <div class="mg-top20" v-for="(item,index) in cats" :key="item.cat_id">
                        <my-sub-title>{{item.cat_cname}}</my-sub-title>
                        <div class="bg-f8 mg-top10" v-for="(item2,index2) in item.children" :key="item.cat_id2">
                            <div class="pd-5 f-bd tcenter bg-back">{{item.cat_cname}} - {{item2.cat_cname}}</div>
                            <div class="flex-box border-top-line f-bd">
                                <div class="width-250 tleft">商品ID(goods_id)</div>
                                <div class="flex-box-bd tleft">名称</div>
                                <div class="width-80 tleft">面值</div>
                                <div class="width-80 tleft">结算价</div>
                            </div>
                            <div class="flex-box border-bottom-line" v-for="(item3,index3) in item2.goods" :key="item3.org_goods_id">
                                <div class="width-60">
                                    <myImgshow :src="item3.img_lnk" @onClick="$base.alertImg(item3.img_lnk, item3.goods_cname)"></myImgshow>
                                </div>
                                <div style="width: 10px"></div>
                                <div class="width-180 tleft">{{item3.goods_id}}</div>
                                <div class="flex-box-bd tleft">
                                    <el-tag size="mini" :class="item3.org_goods_id != '' && item3.org_goods_status == '1'?'bg-green':'bg-gray'">
                                        {{item3.org_goods_status_cdesc || '未配置'}}
                                    </el-tag>
                                    <div class="mg-top5 f-bd">{{item3.goods_cname}}</div>
                                </div>
                                <div class="width-80 tleft f-red">{{item3.new_price * 1}}元</div>
                                <div class="width-80 tleft f-blue">
                                    <span v-if="item3.cost_amt != ''">{{item3.cost_amt * 1}}元</span>
                                    <span v-else>按约定</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="flex-box f-bd f14">
                        <div class="flex-box-bd"></div>
                        <div>{{$t('date')}}{{$t('x_mh')}}{{$moment().format('YYYY-MM-DD HH:mm')}}</div>
                    </div>
                </div>
            </div>
        </myPage>
    </div>
</template>

<script>
    import myImgshow from '../../../components/myImgshow'
    export default {
        name:"dp-setup",
        components:{
            myImgshow
        },
        data:function(){
            return{
                show_up_flag: '1',
                info: {},
                vendors:[],
                cats:[],
                printObj:{
                    id:'#print_area',
                    popTitle: '-',
                    endCallback(){}
                }
            }
        },
        activated:function(){
            this.$base.setMenuOpens();
        },
        mounted: function(){
            this.$base.setMenuOpens();
            this.getInfo();
        },
        methods:{
            getInfo: function(){
                var data = {
                    show_up_flag: this.show_up_flag
                }
                this.$base.showLoading();
                this.$request.sendPost("org-dp/before-upd", data,(success,data,error)=>{
                    this.$base.hideLoading();
                    if(success){
                        this.info = data.info;
                        this.vendors = data.vendors;
                        this.cats = data.cats;
                    }
                    else{
                        this.$base.alertErr(error.errmsg);
                    }
                });
            },
            chkResetApiKey: function(){
                if(this.info.api_key == ''){
                    this.resetApiKey();
                }
                else{
                    this.$base.confirm('您确定要更新当前Api秘钥吗？更新后立即生效，请慎重！',()=>{
                        this.resetApiKey();
                    });
                }
            },
            resetApiKey: function(){
                this.$base.showLoading();
                this.$request.sendPost("org-dp/reset-api-key", {},(success,data,error)=>{
                    this.$base.hideLoading();
                    if(success){
                        setTimeout(()=>{
                            this.info.api_key = data;
                            this.$base.alertSuccess('[' + data + ']秘钥已更新，请不要在接口中进行传送，并且已保管好');
                        },'500');
                    }
                    else{
                        this.$base.alertErr(error.errmsg);
                    }
                });
            }
        }
    }
</script>

<style scoped >
</style>



// WEBPACK FOOTER //
// src/pages/dp/setup/list.vue